import { render, staticRenderFns } from "./document-attachment.vue?vue&type=template&id=2ea5884d&scoped=true&"
import script from "./document-attachment.vue?vue&type=script&lang=js&"
export * from "./document-attachment.vue?vue&type=script&lang=js&"
import style0 from "./document-attachment.vue?vue&type=style&index=0&id=2ea5884d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ea5884d",
  null
  
)

export default component.exports